import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useReturnRequestsTimeChart from "@babackapp/private-api-client/client/use-return-requests-time-chart";
import { useDashboardFilters } from "./dashboard-filters";

export default function useCurrentFiltersReturnRequestsStats() {
  const { data: shop } = useCurrentShopSuspense();
  const { toTimestamp, fromTimestamp, productId, variantId, resolution, reason } =
    useDashboardFilters();

  return useReturnRequestsTimeChart(shop.id, {
    fromTimestamp,
    toTimestamp: toTimestamp ?? 0,
    productId,
    variantId,
    resolution,
    reason
  });
}
